import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  title: string;
  children: React.ReactNode;
};

/**
 * ガイドページ内のセクション区切り
 */
const GuideSection: React.FC<Props> = ({ title, children }) => {
  return (
    <Stack spacing={1.5}>
      <Typography variant="subtitle1" fontWeight={600}>
        {title}
      </Typography>
      <Box sx={{ pl: 1 }}>{children}</Box>
    </Stack>
  );
};

export default GuideSection;
